import {DateTime} from 'luxon';
import {TtActivityEntry} from '../interfaces/time-tracking/tt-activity-entry';


export class TimeTrackingHelper {

  /**
   *
   * @param ttActivityEntry
   * @param ttActivityEntries
   */
  public static checkOverlapping(ttActivityEntry: TtActivityEntry, ttActivityEntries: TtActivityEntry[]): boolean {
    const timeFrom = DateTime.fromISO(ttActivityEntry.timeFrom);
    const timeTo = DateTime.fromISO(ttActivityEntry.timeTo);

    return ttActivityEntries.some(_ttActivityEntry => {
      return this.checkOverlappingByTime(timeFrom, timeTo, _ttActivityEntry);
    });
  }

  /**
   *
   * @param ttActivityEntry
   * @param ttActivityEntries
   */
  public static getOverlappingTtActivityEntry(ttActivityEntry: TtActivityEntry, ttActivityEntries: TtActivityEntry[]): TtActivityEntry {
    const timeFrom = DateTime.fromISO(ttActivityEntry.timeFrom);
    const timeTo = DateTime.fromISO(ttActivityEntry.timeTo);

    return ttActivityEntries.find(_ttActivityEntry => {
      return this.checkOverlappingByTime(timeFrom, timeTo, _ttActivityEntry);
    });
  }

  /**
   *
   * @param timeFrom
   * @param timeTo
   * @param ttActivityEntry
   */
  public static checkOverlappingByTime(timeFrom: DateTime, timeTo: DateTime, ttActivityEntry: TtActivityEntry): boolean {
    const entryTimeFrom = DateTime.fromISO(ttActivityEntry.timeFrom);
    const entryTimeTo = DateTime.fromISO(ttActivityEntry.timeTo);

    return timeFrom < entryTimeTo && timeTo > entryTimeFrom;
  }

  /**
   *
   * @param ttActivityEntry
   * @param ttActivityEntries
   */
  public static checkSpaceBetween(ttActivityEntry: TtActivityEntry, ttActivityEntries: TtActivityEntry[]): {
    before: boolean,
    after: boolean
  } {
    const timeFrom =
      ttActivityEntry.timeFromTravel ? DateTime.fromISO(ttActivityEntry.timeFromTravel) : DateTime.fromISO(ttActivityEntry.timeFrom);
    const timeTo = DateTime.fromISO(ttActivityEntry.timeTo);
    let isBefore: boolean = false;
    let isAfter: boolean = false;

    for(const _ttActivityEntry of ttActivityEntries) {
      const _timeFrom =
        _ttActivityEntry.timeFromTravel ? DateTime.fromISO(_ttActivityEntry.timeFromTravel) : DateTime.fromISO(_ttActivityEntry.timeFrom);
      const _timeTo = DateTime.fromISO(_ttActivityEntry.timeTo);

      if(_timeFrom < timeFrom && !isBefore) {
        isBefore = true;
      }
      else if(_timeFrom > timeFrom && !isAfter) {
        isAfter = true;
      }

      if(timeFrom.hasSame(_timeTo, 'minute')) {
        isBefore = false;
      }

      if(timeTo.hasSame(_timeFrom, 'minute')) {
        isAfter = false;
      }
    }

    return {
      before: isBefore,
      after: isAfter
    };
  }

  /**
   *
   * @param ttActivityEntry
   */
  public static getTimeFrom(ttActivityEntry: TtActivityEntry): DateTime {
    return ttActivityEntry.timeFromTravel ?
      DateTime.fromISO(ttActivityEntry.timeFromTravel) : DateTime.fromISO(ttActivityEntry.timeFrom);
  }

}
